export const getUser = (state: ReduxState) => state.userReducer?.user;
export const getModals = (state: ReduxState) => state.notificationReducer?.modals;
export const getAlerts = (state: ReduxState) => state.notificationReducer?.alerts;
export const getShowNetworkBanner = (state: ReduxState) => state.notificationReducer?.showNoNetworkBanner;
export const getUsers = (state: ReduxState) => state.usersReducer?.users;
export const getSidePanelIsOpen = (state: ReduxState) => state.importExportSidePanelReducer?.isOpen;
export * from './configSelectors';
export * from './rulesSelectors';
export * from './reportsSelectors';
export * from './breadcrumbsSelectors';
export * from './appstateSelector';
export * from './groupSelector';
export * from './groupViewSelector';
